import axios from 'axios';
import Eos from 'eosjs';

// Store modules
import auth from './auth';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
const AWS = require('aws-sdk')
var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;



// initial state
const state = {
    transactionStatus: {},
    freshKeys: {}
}

const getters = { 
}

const mutations = {
  setTransactionStatus (state, trx) {
    console.log(trx)
    state.transactionStatus = trx
  },
  commitFreshKeys (state, trx) {
    console.log(trx)
    state.freshKeys = trx
  },
  keyDestroy (state) {
    state.freshKeys = {}
  },
  clearData (state) {
    state.transactionStatus = {},
    state.freshKeys = {}
  }
}

const actions = {
    keyChange: function (context, params) {
        console.log('getting data')
        auth.state.getSession.then((token) => {
            console.log(token)
            var config = {
                headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                      'accesstoken': token.accessToken.jwtToken}
            };

        axios
          .post('https://api.smart.press:3000/db/keyChange', {
              data: {
                activeKey: params.activeKey,
                accountName: params.accountName
              }
            }, config)
          .then(trx => (context.commit('util/commitLogMessage', trx.data, { root: true })))
      })  
    },
    keyCreate: function (context, params) {
        console.log('getting data')
        auth.state.getSession.then((token) => {
            console.log(token)
            var config = {
                headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                      'accesstoken': token.accessToken.jwtToken}
            };

        axios
          .post('https://api.smart.press:3000/db/keyCreate', {
              data: {
              }
            }, config)
          .then(trx => (context.commit('eosJsFunc/commitFreshKeys', trx.data, { root: true })))
      })  
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

